import { render } from "./ORMObjectEditor.vue?vue&type=template&id=305c96d0"
import script from "./ORMObjectEditor.vue?vue&type=script&lang=js"
export * from "./ORMObjectEditor.vue?vue&type=script&lang=js"

import "./ORMObjectEditor.vue?vue&type=style&index=0&id=305c96d0&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__